export const getErrorMessage = (e) => {
  const errMessage = e.toString();
  let message = '';
  
  if (errMessage.includes('HttpRequest failed')) {
    message = 'Проверьте соединение с интернетом';
  }

  if (errMessage.includes('107')) {
    message = 'Нет ответа от сервера, попробуйте позже';
  }

  return message;
};
